import { trackMetricsLoaded } from './internal/trackMetricsLoaded';
export { createMetricsFactory } from './internal/createMetricsFactory';
export { setBeaconApi, setStaticAppInfo } from './internal/metricsApi';
trackMetricsLoaded();